import { faCalendarCircleExclamation } from '@fortawesome/pro-regular-svg-icons/faCalendarCircleExclamation';
import { faCalendarLinesPen } from '@fortawesome/pro-regular-svg-icons/faCalendarLinesPen';
import { faCalendarStar } from '@fortawesome/pro-regular-svg-icons/faCalendarStar';
import { faFileCertificate } from '@fortawesome/pro-regular-svg-icons/faFileCertificate';
import { faTimer } from '@fortawesome/pro-regular-svg-icons/faTimer';
import { faTrophyStar } from '@fortawesome/pro-regular-svg-icons/faTrophyStar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar, Box, ListItem, ListItemAvatar, ListItemButton, ListItemText, Stack, Typography } from '@mui/material';
import { MprcBoxDrawer, MprcLink } from 'components';
import { UserShortView } from 'generated/CoreApi_v1';
import { Formaters } from 'lib/Formaters';
import { useModalUserProfile } from 'providers/UserProfileProvider';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const TrainingViewRegistrationBox = ({ registrationEnrollAvailableFrom, registrationEnrollAvailableUntil }: { registrationEnrollAvailableFrom: Date | null; registrationEnrollAvailableUntil: Date | null; }) => {
    const { t } = useTranslation("lms");

    return (
        <Stack spacing={1} direction="row" color="muted.main">
            <FontAwesomeIcon icon={faCalendarLinesPen} size="3x" />
            <div>
                <Typography variant="body2" fontWeight="bold" component="p">
                    {
                        registrationEnrollAvailableFrom != null && registrationEnrollAvailableUntil != null
                            ? <small>{Formaters.performaDateRange(registrationEnrollAvailableFrom, registrationEnrollAvailableUntil)}</small>
                            : registrationEnrollAvailableFrom != null
                                ? Formaters.performaDate(registrationEnrollAvailableFrom, { preposition: "none" })
                                : Formaters.performaDate(registrationEnrollAvailableUntil, { preposition: "none" })
                    }
                </Typography>
                <Typography variant="caption" component="p">
                    {
                        registrationEnrollAvailableFrom != null && registrationEnrollAvailableUntil != null
                            ? t("Training.Literals.RegistrationEnrollText")
                            : registrationEnrollAvailableFrom != null
                                ? t("Training.Literals.RegistrationEnrollAvailableFromText")
                                : t("Training.Literals.RegistrationEnrollAvailableUntilText")
                    }
                </Typography>
            </div>
        </Stack>
    );
};


export const TrainingViewStartExecutionBox = ({ executionStartDate }: { executionStartDate: Date | null; }) => {
    const { t } = useTranslation("lms");

    return (
        <Stack spacing={1} direction="row" color="muted.main">
            <FontAwesomeIcon icon={faCalendarStar} size="3x" />
            <div>
                <Typography variant="body2" fontWeight="bold" component="p">
                    {
                        executionStartDate == null
                            ? t("Training.Literals.StartAnyTimeText")
                            : Formaters.localeDate(executionStartDate)
                    }
                </Typography>
                <Typography variant="caption" component="p">{t("Training.Literals.StartDateText")}</Typography>
            </div>
        </Stack>
    );
};

export const TrainingViewEndExecutionBox = ({ dueDays, dueDate }: { dueDays: number | null; dueDate: Date | null; }) => {
    const { t } = useTranslation("lms");

    return (
        <Stack spacing={1} direction="row" color="muted.main">
            <FontAwesomeIcon icon={faCalendarCircleExclamation} size="3x" />
            <div>
                <Typography variant="body2" fontWeight="bold" component="p">
                    {
                        dueDays
                            ? `${dueDays} ${dueDays == 1 ? t("shared:Literal.Day") : t("shared:Literal.Days")}`
                            : Formaters.localeDate(dueDate)
                    }
                </Typography>
                <Typography variant="caption" component="p">
                    {dueDays ? t("Training.Literals.DueDaysText") : t("Training.Literals.DueDateText")}
                </Typography>
            </div>
        </Stack>
    );
};

export const TrainingViewDurationBox = ({ trainingDurationFormated }: { trainingDurationFormated: string; }) => {
    const { t } = useTranslation("lms");

    return (
        <Stack spacing={1} direction="row" color="muted.main">
            <FontAwesomeIcon icon={faTimer} size="3x" />
            <div>
                <Typography variant="body2" fontWeight="bold" component="p">{trainingDurationFormated}</Typography>
                <Typography variant="caption" component="p">{t("Training.Literals.DurationText")}</Typography>
            </div>
        </Stack>
    );
};

export const TrainingViewInstructorsBox = ({ instructors }: { instructors: UserShortView[]; }) => {
    const { t } = useTranslation("lms");
    const [viewAllInstructors, setViewAllInstructors] = useState<boolean>(false);
    const { showUser } = useModalUserProfile();

    return (
        <>
            <Stack spacing={1} direction="row" color="muted.main">
                <Avatar variant="circular"
                    src={instructors[0].thumbnailUrl}
                    sx={{ width: 48, height: 48 }}
                />
                <Box sx={{ overflow: "hidden" }}>
                    <Typography variant="body2" fontWeight="bold" component="p" noWrap>{instructors[0].name}</Typography>
                    {
                        instructors.length == 1
                            ? <Typography variant="caption" component="p">{t("Training.Literals.InstructorText")}</Typography>
                            : <MprcLink variant="linkAction" onClick={() => setViewAllInstructors(true)}>{t("Training.Literals.InstructorsText")}</MprcLink>
                    }
                </Box>
            </Stack>
            <MprcBoxDrawer
                open={viewAllInstructors}
                onClose={() => setViewAllInstructors(false)}
                title={"Instrutores"}
                content={
                    <>
                        {
                            instructors.map((item, index) => {
                                return (
                                    <ListItem key={index} disablePadding disableGutters>
                                        <ListItemButton disableGutters onClick={() => showUser(item.userId)}>
                                            <ListItemAvatar sx={{ minWidth: 40 }}>
                                                <Avatar
                                                    variant="circular"
                                                    src={item.thumbnailUrl}
                                                    sx={(theme) => ({ width: 32, height: 32, backgroundColor: theme.palette.grey[200] })}
                                                />
                                            </ListItemAvatar >
                                            <ListItemText
                                                primary={item.name}
                                                title={item.name}
                                                primaryTypographyProps={{ noWrap: true, variant: "h6" }}
                                            />

                                        </ListItemButton>
                                    </ListItem>
                                );
                            })
                        }
                    </>
                }
            >
            </MprcBoxDrawer>
        </>
    );
};

export const TrainingViewCertificateBox = (
    { certificateTrainingValidityMonthDay, certificateTrainingValidityDays }: {
        certificateTrainingValidityMonthDay: number | null,
        certificateTrainingValidityDays: number | null,
    }) => {
    const { t } = useTranslation("lms");

    return (
        <Stack spacing={1} direction="row" color="muted.main">
            <FontAwesomeIcon icon={faFileCertificate} size="3x" />
            <div>
                <Typography variant="body2" fontWeight="bold" component="p">{t("Training.Literals.CertificateText")}</Typography>
                <Typography variant="caption" component="p">
                    {
                        certificateTrainingValidityMonthDay != null
                            ? Formaters.performaMonthDay(certificateTrainingValidityMonthDay)
                            : certificateTrainingValidityDays != null
                                ? t("Training.Literals.CertificateValidityDays", { count: certificateTrainingValidityDays })
                                : t("Training.Literals.OnCompleteText")
                    }
                </Typography>
            </div>
        </Stack>
    );
};

export const TrainingViewAwardBox = ({ awardApprovalPoints, awardEnrollPoints }: { awardApprovalPoints: number, awardEnrollPoints: number; }) => {
    const { t } = useTranslation("lms");

    const hasEnrollPoints = awardEnrollPoints > 0;
    const hasApprovalPoints = awardApprovalPoints > 0;

    return (
        <Stack spacing={1} direction="row" color="muted.main">
            <FontAwesomeIcon icon={faTrophyStar} size="3x" />
            <div>
                <Typography variant="body2" fontWeight="bold" component="p">
                    {t("Training.Literals.AwardTotalPoints", { count: (awardEnrollPoints ?? 0) + (awardApprovalPoints ?? 0) })}
                </Typography>
                <Typography variant="caption" component="p">
                    {hasEnrollPoints && hasApprovalPoints ?
                        <>
                            {awardEnrollPoints ? `${awardEnrollPoints} ${t("Training.Literals.OnEnrollAwardText")}` : ""}
                            <span>&nbsp;|&nbsp;</span>
                            {awardApprovalPoints ? `${awardApprovalPoints} ${t("Training.Literals.OnCompleteAwardText")}` : ""}
                        </>
                        : hasEnrollPoints ? t("Training.Literals.OnEnrollAwardOnlyText")
                            : hasApprovalPoints ? t("Training.Literals.OnCompleteAwardOnlyText") : ""
                    }
                </Typography>
            </div>
        </Stack>
    );
};

export const TrainingViewMultipleClassesBox = ({ onClick }: { onClick: () => void; }) => {
    const { t } = useTranslation("lms");

    return (
        <Stack spacing={1} direction="row" color="muted.main">
            <FontAwesomeIcon icon={faCalendarStar} size="3x" />
            <div>
                <Typography variant="body2" fontWeight="bold" component="p">{t("Training.Literals.MultipleClassesText")}</Typography>
                <MprcLink variant="linkAction" onClick={onClick}>{t("Training.Literals.ViewAllClassroomsText")}</MprcLink>
            </div>
        </Stack>
    );
};
